import api from "../config/axios";

/**
 * Recupera la struttura del menu per un dato gruppo utente.
 * Assumiamo che l'endpoint backend sia /api/menu/:gruppoId
 * @param {string|number} gruppoId L'ID del gruppo utente.
 * @returns {Promise<object>} Dati del menu (es. { tree: [...], functions: [...] })
 */
export const getMenuData = async (gruppoId) => {
  if (!gruppoId) {
    throw new Error("ID Gruppo mancante per recuperare il menu.");
  }
  try {
    // Usa l'endpoint corretto come da backend (menuRoutes.js)
    const response = await api.get(`/menu/${gruppoId}`);
    // Assumiamo che la risposta contenga { tree: [], functions: [] }
    return response.data;
  } catch (error) {
    console.error("Errore nel recupero del menu:", error.response?.data || error.message);
    throw error.response?.data || new Error("Errore nel recupero del menu");
  }
};

// Potresti aggiungere qui altre funzioni se necessario (es. per refresh forzato, ecc.)